<script setup lang="ts">
import { GpTextInput } from '@gportal/uikit';
import { useUserStore } from 'gpcore-apikit/store/pinia/user';
import type { Client } from 'gpcore-grpc/gpcore/api/auth/v1/client_pb';
import type { CreateClientResponse } from 'gpcore-grpc/gpcore/api/auth/v1/responses_pb';
import AsyncModal from 'gpcore-uikit/components/new/AsyncModal.vue';
import onModalShow from 'gpcore-uikit/composables/onModalShow';
import useFormData from 'gpcore-uikit/composables/useFormData';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    show: boolean;
  }>(),
  {
    show: false,
  },
);

const emit = defineEmits<{
  close: [];
  created: [Client];
}>();

const userStore = useUserStore();

const initialValues = {
  name: '',
  description: '',
};

const { form, resetForm } = useFormData(initialValues);
const isValid = computed(() => form.name.length > 0 && form.description.length > 0);
const createClient = () => userStore.createClient(form);

const onDone = (response: CreateClientResponse) => {
  emit('created', response.client);
};

onModalShow(props, () => {
  resetForm();
});
</script>

<template>
  <AsyncModal
    :show="show"
    :header-icon="['fas', 'fa-key']"
    header-text="Create new client"
    :async-function="createClient"
    :is-valid="isValid"
    confirm-text="Create"
    @close="emit('close')"
    @done="onDone"
  >
    <template #content>
      <div class="tw-mb-8 tw-px-4">
        <GpTextInput
          class="tw-mb-4"
          :required="true"
          label="Name*"
          v-model="form.name"
          name="name"
          input-id="add-client-name"
        />
        <GpTextInput
          :required="true"
          label="Description*"
          v-model="form.description"
          name="description"
          input-id="add-client-description"
        />
      </div>
    </template>
  </AsyncModal>
</template>
